import {
	WithdrawalDataDto,
	WithdrawalInitRequestDataDto,
} from "@api-types/withdrawal";
import { httpClient } from "@utils";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";

export class WithdrawalApiService {
	static baseUrl(context: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/online-payments/payout`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";

		return appHeaders;
	};
	static async getAvailableMethods(
		bettingAccountTypeId: string,
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<WithdrawalDataDto> {
		const context = getApiRequestContext(options);

		return await httpClient.get(
			`${this.baseUrl(context)}/available-methods?bettingAccountTypeId=${bettingAccountTypeId}`,
			this.getRequestHeaders(context)
		);
	}

	static async initializeNewWithdrawalProcess(
		data: WithdrawalInitRequestDataDto,
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<WithdrawalDataDto> {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			`${this.baseUrl(context)}/initialize`,
			JSON.stringify(data),
			this.getRequestHeaders(context)
		);
	}
}
